import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Typography } from '@mui/material';
import SearchableSelect from 'components/Forms/searchable/SearchableSelect';

function DefaultTierSelector({ tiers, defaultTier, defaultTierColor, onChange }) {
  const sortedTiers = React.useMemo(
    () => [...(tiers || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [tiers]
  );

  const handleChange = (event) => {
    const name = event.target.value;
    const tier = sortedTiers.find((t) => (t.name || '').trim() === name);
    if (tier) {
      onChange(name, tier.color);
    }
  };

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Default tier (fallback for new customers with 0 orders)
      </Typography>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="default-tier-label">Default tier</InputLabel>
        <SearchableSelect
          labelId="default-tier-label"
          value={defaultTier || ''}
          label="Default tier"
          onChange={handleChange}
        >
          {sortedTiers.map((t) => (
            <MenuItem key={t.id || t.name} value={t.name || ''}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: 0.5,
                    bgcolor: t.color || '#ccc',
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                />
                {t.label || t.name}
              </Box>
            </MenuItem>
          ))}
        </SearchableSelect>
      </FormControl>
    </Box>
  );
}

export default DefaultTierSelector;
